import { render, staticRenderFns } from "./HandMenu.vue?vue&type=template&id=3910e2c2&scoped=true&"
import script from "./HandMenu.vue?vue&type=script&lang=js&"
export * from "./HandMenu.vue?vue&type=script&lang=js&"
import style0 from "./HandMenu.vue?vue&type=style&index=0&id=3910e2c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3910e2c2",
  null
  
)

export default component.exports